// src/api/products.js
import api from "./axios";

function asArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.products)) return payload.products;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.items)) return payload.data.items;
  if (Array.isArray(payload?.data?.products)) return payload.data.products;
  return [];
}

function apiError(error, fallback) {
  const source = error?.response?.data;
  const next = new Error(source?.message || error?.message || fallback);
  next.code = source?.code || "";
  next.details = source?.details || null;
  next.status = error?.response?.status || 0;
  return next;
}

export function normalizeProduct(product = {}) {
  const id = product._id || product.id;
  const name = product.nombre || product.name || "";
  const description = product.descripcion || product.description || "";
  const category = product.categoria || product.category || "General";
  const subcategory = product.subcategoria || product.subcategory || product.subCategory || "";
  const price = product.precio ?? product.price ?? 0;
  const basePrice = product.precioBase ?? product.basePrice ?? price;
  const active = product.activo ?? product.active ?? true;
  const currency = String(product.precioMoneda || product.priceCurrency || product.currency || product.pricing?.currency || "ARS").toUpperCase();

  return {
    ...product,
    _id: id,
    id,
    nombre: name,
    name,
    descripcion: description,
    description,
    categoria: category,
    category,
    subcategoria: subcategory,
    subcategory,
    precio: Number(price) || 0,
    price: Number(price) || 0,
    precioBase: Number(basePrice) || 0,
    basePrice: Number(basePrice) || 0,
    compareAtPrice: product.compareAtPrice ?? product.precioTachadoWeb ?? null,
    currency,
    activo: active,
    active,
    images: Array.isArray(product.images) ? product.images : [],
  };
}

async function listProductsFrom(endpoint, params = {}, options = {}) {
  try {
    const {
      q,
      categoria,
      subcategoria,
      subcategory,
      tipo,
      type,
      inStock,
      gastronomicMenu,
      page,
      pageSize,
      sortBy,
      sortDir,
    } = params || {};
    const { data } = await api.get(endpoint, {
      params: {
        ...(q ? { q } : {}),
        ...(categoria ? { categoria } : {}),
        ...((subcategoria || subcategory)
          ? { subcategoria: subcategoria || subcategory }
          : {}),
        ...((tipo || type) ? { tipo: tipo || type } : {}),
        ...(typeof inStock === "boolean" ? { inStock } : {}),
        ...(typeof gastronomicMenu === "boolean" ? { gastronomicMenu } : {}),
        ...(page ? { page } : {}),
        ...(pageSize ? { pageSize } : {}),
        ...(sortBy ? { sortBy } : {}),
        ...(sortDir ? { sortDir } : {}),
      },
      headers: { "Cache-Control": "no-cache" },
      ...(options?.signal ? { signal: options.signal } : {}),
    });
    if (!data?.ok) throw new Error(data?.message || "No se pudieron listar productos.");
    const items = asArray(data).map(normalizeProduct);
    return { ...data, items, products: items, total: data.total ?? items.length };
  } catch (error) {
    throw apiError(error, "Error listando productos.");
  }
}


export function listProducts(params = {}, options = {}) {
  return listProductsFrom("/products", params, options);
}

export function listPublicProducts(params = {}, options = {}) {
  return listProductsFrom("/public/products", params, options);
}

export async function listProductCategories(options = {}) {
  try {
    const { signal, tipo, type } = options || {};
    const requestedType = tipo || type;
    const { data } = await api.get("/public/products/categories", {
      params: requestedType ? { tipo: requestedType } : undefined,
      headers: { "Cache-Control": "no-cache" },
      ...(signal ? { signal } : {}),
    });
    if (!data?.ok) throw new Error(data?.message || "No se pudieron listar categorías.");
    const categories = Array.isArray(data?.categories)
      ? data.categories
      : Array.isArray(data?.items)
        ? data.items
        : [];
    return { ...data, categories, items: categories };
  } catch (error) {
    throw apiError(error, "Error listando categorías.");
  }
}

export async function getProductById(id) {
  try {
    if (!id) throw new Error("Falta id de producto.");
    const { data } = await api.get(`/products/${id}`, {
      headers: { "Cache-Control": "no-cache" },
    });
    if (!data?.ok) throw new Error(data?.message || "No se pudo obtener el producto.");
    const raw = data?.item || data?.product || data?.data?.item || data?.data || null;
    return normalizeProduct(raw || {});
  } catch (error) {
    throw apiError(error, "Error obteniendo producto.");
  }
}

export async function quoteProducts(items = []) {
  try {
    const { data } = await api.post("/products/quote", { items }, {
      headers: { "Cache-Control": "no-cache" },
    });
    if (!data?.ok) throw new Error(data?.message || "No se pudo actualizar el carrito.");
    return data;
  } catch (error) {
    throw apiError(error, "No se pudieron validar los precios del carrito.");
  }
}
